<template>
	<div class="v-input" :class="{active,empty:!value}" :style="style" ref="input">
		<div class="v-input-before">
			<slot name="before" v-if="'before' in $slots"/>
      <v-icon :type="iconBefore" v-else-if="iconBefore"/>
		</div>
		<div class="v-input-inner">
			<input :type="originType" :placeholder="placeholder" :maxlength="maxLength" :spellcheck="spellcheck||'false'" :value="value" @input="input" @focus="active=true" @blur="active=false" ref="inner"/>
      <div class="v-input-number">
        <v-icon type="v-icon-input-number-plus" @click="counter(step)"/>
        <v-icon type="v-icon-input-number-minus" @click="counter(-step)"/>
      </div>
      <div class="v-input-clear" @click="clear">
        <slot name="clear" v-if="'clear' in $slots"/>
			  <v-icon type="v-icon-input-clear" v-else/>
      </div>
		</div>
		<div class="v-input-after">
      <slot name="after" v-if="'after' in $slots"/>
      <v-icon :type="iconAfter" v-else-if="iconAfter"/>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    type: {
      default: null
    },
    step: {
      default: 1
    },
    decimal: {
      default: null
    },
    placeholder: {
      default: null
    },
    min: {
      default: null
    },
    max: {
      default: null
    },
    maxLength: {
      default: null
    },
    iconBefore: {
      default: null
    },
    iconAfter: {
      default: null
    },
    validator: {
      default: null
    },
    width: {
      default: ""
    },
    height: {
      default: ""
    },
    spellcheck: {
      default: null
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    originType() {
      return { integer: "number" }[this.type] || this.type;
    },
    style() {
      return {
        width: this.$filter.unit(this.width, "px"),
        height: this.$filter.unit(this.height, "px")
      };
    }
  },
  methods: {
    input(e) {
      let value = e.target.value;
      if (
        (Object.assign(
          {
            number: v =>
              /^(\-?\d|\-?[1-9]\d*|\-?\d\.\d+|\-?[1-9]\d*\.\d+)?$/gm.test(v),
            integer: v => /^(\-?\d|\-?[1-9]\d*)?$/gm.test(v),
            phone: v => /^1\d{0,10}$/gm.test(v)
          },
          this.validator
        )[this.type] || (v => true))(value)
      ) {
        this.$emit(
          "input",
          this.limit(this.originType == "number" ? Number(value) : value)
        );
      }
    },
    search(text) {
      this.$emit("search", text), this.$refs.inner.blur();
    },
    limit(value) {
      if (this.type == "number" && this.decimal) {
        value = String(value).replace(
          new RegExp(`(\\.\\d{1,${this.decimal}})\\d*$`),
          "$1"
        );
      }
      if (!isNaN(parseFloat(this.min))) {
        value = Math.max(this.min, value);
      }
      if (!isNaN(parseFloat(this.max))) {
        value = Math.min(value, this.max);
      }
      return value;
    },
    counter(step) {
      this.$emit("input", this.limit((Number(this.value) || 0) + step));
      this.focus();
    },
    clear() {
      this.$emit("input", ""), this.search({ key: "Enter" });
    },
    focus() {
      this.$refs.inner.focus();
    },
    keep(e) {
      e.target.focus();
    },
    search(e) {
      if (e.key == "Enter") {
        this.$emit("search", this.value);
      }
    }
  },
  mounted() {
    this.$bindEvents(this.$refs.inner);
    if ("keep-active" in this.$attrs) {
      this.$refs.inner.addEventListener("blur", this.keep);
    }
    if ("search" in this.$listeners) {
      this.$refs.inner.addEventListener("keyup", this.search);
    }
  },
  beforeDestory() {
    if ("keep-active" in this.$attrs) {
      this.$refs.inner.removeEventListener("blur", this.keep);
    }
    if ("search" in this.$listeners) {
      this.$refs.inner.removeEventListener("keyup", this.search);
    }
  }
};
</script>

<style lang="less">
.v-input {
  width: 180px;
  height: 32px;
  font-size: 14px;
  overflow: hidden;
  border-radius: 4px;
  white-space: nowrap;
  line-height: initial;
  display: inline-flex;
  box-sizing: border-box;
  vertical-align: middle;
  border: 1px solid #dddddd;
  > .v-input-inner {
    width: 100%;
    height: 100%;
    position: relative;
    > input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      padding: 4px 6px;
      font-size: inherit;
      border-radius: 3px;
      box-sizing: border-box;
      &[type="number"] {
        -moz-appearance: textfield;
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
        }
        + .v-input-number {
          display: flex;
          + .v-input-clear {
            right: 20px;
          }
        }
      }
    }
    > .v-input-number {
      top: 0px;
      right: 0px;
      bottom: 0px;
      width: 20px;
      display: none;
      color: #999999;
      position: absolute;
      text-align: center;
      flex-direction: column;
      background-color: #ffffff;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-left: 1px solid #eeeeee;
      transition: 300ms;
      > .v-icon {
        flex: 1;
        display: flex;
        cursor: pointer;
        line-height: 12px;
        font-size: inherit;
        align-items: center;
        justify-content: center;
        transition: 300ms;
        &:first-child {
          border-bottom: 1px solid #eeeeee;
        }
        &:hover {
          flex: 2;
          color: #41b883;
        }
      }
    }
    > .v-input-clear {
      top: 0px;
      right: 0px;
      bottom: 0px;
      opacity: 0;
      margin: 4px;
      cursor: pointer;
      color: #999999;
      position: absolute;
      visibility: hidden;
      transition: 300ms;
    }
  }
  > .v-input-before {
    color: #999999;
    padding: 4px 0px 4px 6px;
    &:empty {
      display: none;
    }
  }
  > .v-input-after {
    color: #999999;
    padding: 4px 6px 4px 0px;
    &:empty {
      display: none;
    }
  }
  .v-icon {
    font-size: inherit;
  }
  &.active {
    border-color: #41b883;
    &[clearable]:not(.empty) {
      > .v-input-inner {
        > input {
          padding-right: 22px;
          &[type="number"] {
            padding-right: 40px;
          }
        }
        > .v-input-clear {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
  &[disabled] {
    cursor: no-drop;
    filter: grayscale(100%) brightness(90%);
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/input.vue